import React from 'react';

import PropTypes from 'prop-types';

import { Flex, Text } from '@adsk/alloy-react-box';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

const MissingEntities = ({ count }: { count: number }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <Flex alignItems="center" justifyContent="center" padding="24px">
      <Tooltip
        content={T.translate('MISSING_ENTITIES_TOOLTIP', { context: count })}
      >
        <Flex alignItems="center" justifyContent="center">
          <AlertWarningIcon
            style={{
              color: theme.colors.charcoal700,
            }}
          />
          <Text typography="bodySmall" color="charcoal700" marginLeft="9px">
            {T.translate('MISSING_ENTITIES_MESSAGE', { context: count })}
          </Text>
        </Flex>
      </Tooltip>
    </Flex>
  );
};

MissingEntities.propTypes = {
  /** Number of missing entities */
  count: PropTypes.number.isRequired,
};

export default MissingEntities;
